import React, { useState, useEffect, useContext } from 'react'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { Auth } from '../../../../contexts/allContext'
import { useRequest } from '../../../../hooks/useRequest'
import PopupV1 from '../../../Resources/PopupV1/PopupV1'
import classes from './SubsPopup.module.css'

export default function SubsPopup({ setForm, form, singleSellerInfo }) {
    const currentPlan = singleSellerInfo?.Seller?.plan_type || 'basic'
    const subscriptionInfo = singleSellerInfo?.SellerSubscription || {}

    const { handleSubmit, handleFetch } = useRequest()
    const { stateAuth } = useContext(Auth)
    const token = stateAuth?.token

    const [plans, setPlans] = useState([])
    const [selectedPlan, setSelectedPlan] = useState(null)

    const [formData, setFormData] = useState({
        plan_duration: '',
        start_date: '',
        end_date: '',
    })

    const toDateInput = (iso) => (iso ? iso.split('T')[0] : '')

    const fetchPlans = async () => {
        try {
            const { data, isSuccess } = await handleFetch('v1/subscriptions/', {})

            if (isSuccess) {
                setPlans(data)
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchPlans()
    }, [])

    useEffect(() => {
        if (plans.length > 0) {
            const matched = plans.find((p) => p.name === currentPlan)
            setSelectedPlan(matched || null)
        }

        if (subscriptionInfo?.is_subscribed) {
            setFormData({
                plan_duration: subscriptionInfo?.plan_duration || '',
                start_date: toDateInput(subscriptionInfo?.start_date),
                end_date: toDateInput(subscriptionInfo?.end_date),
            })
        }
    }, [plans, currentPlan, subscriptionInfo])

    const showExtraFields = selectedPlan && (selectedPlan.name === 'standard' || selectedPlan.name === 'premium')

    const handleInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
    }

    const handleSubscriptionSubmit = async () => {
        const sellerId = singleSellerInfo?.Seller?.id
        const sellerUserId = singleSellerInfo?.User?.id

        if (!selectedPlan) return toast.error('Plan Name is required')

        const isSubscribed = selectedPlan.name === 'standard' || selectedPlan.name === 'premium'

        if (isSubscribed) {
            if (!formData.plan_duration) return toast.error('Plan Duration is required')
            if (!formData.start_date) return toast.error('Start Date is required')
            if (!formData.end_date) return toast.error('End Date is required')
        }

        const formatStartDate = (date) => `${date}T00:00:01`
        const formatEndDate = (date) => `${date}T23:59:59`

        const payload = {
            plan_id: selectedPlan.id,
            is_subscribed: isSubscribed,
            plan_duration: formData.plan_duration,
            start_date: formatStartDate(formData.start_date),
            end_date: formatEndDate(formData.end_date),
        }

        try {
            const { data, isSuccess } = await handleSubmit(
                `v1/sellers/subscription/${sellerId}`,
                '',
                payload,
                token,
                'PATCH'
            )

            if (isSuccess) {
                toast.success('Subscription Updated Successfully')
                setForm(false)
            }
        } catch (error) {
            console.error('Subscription update failed:', error)
            toast.error('Failed to update subscription')
        }
    }

    return (
        <PopupV1 setForm={setForm} form={form} width="35%">
            <div className={classes.container}>
                <div className={classes.title}>
                    <h2>Subscription Details for {singleSellerInfo?.Seller?.page_name}</h2>
                </div>

                <div className={classes.formLayout}>
                    <div className={classes.formGroup}>
                        <label>Plan Name</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={plans.map((p) => ({
                                    ...p,
                                    label: p.name,
                                    value: p.id,
                                }))}
                                classNamePrefix="react-select"
                                value={
                                    selectedPlan
                                        ? { ...selectedPlan, label: selectedPlan.name, value: selectedPlan.id }
                                        : null
                                }
                                onChange={(v) => setSelectedPlan(v)}
                            />
                        </div>
                    </div>
                </div>

                {showExtraFields && (
                    <>
                        <div className={classes.formGroup}>
                            <label>Plan Duration</label>
                            <input
                                type="text"
                                name="plan_duration"
                                value={formData.plan_duration}
                                onChange={handleInput}
                            />
                        </div>

                        <div className={classes.formLayout2}>
                            <div className={classes.formGroup}>
                                <label>Start Date</label>
                                <input
                                    type="date"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={handleInput}
                                />
                            </div>

                            <div className={classes.formGroup}>
                                <label>End Date</label>
                                <input type="date" name="end_date" value={formData.end_date} onChange={handleInput} />
                            </div>
                        </div>
                    </>
                )}

                <div className={classes.buttonContainer}>
                    <button type="button" onClick={handleSubscriptionSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </PopupV1>
    )
}
